// Importing clock images
import Clock1 from '@/assets/images/clock/clock1-01.png'
import Clock2 from '@/assets/images/clock/clock2-01.png'
import Clock3 from '@/assets/images/clock/clock3-01.png'
import Clock4 from '@/assets/images/clock/clock4-01.png'
import Clock5 from '@/assets/images/clock/clock5-01.png'
import Clock6 from '@/assets/images/clock/clock6-01.png'
import Clock7 from '@/assets/images/clock/clock7-01.png'

export const clock_templates = [{
	id : 1,
	title : 'Clock 1',
	img : Clock1
},{
	id : 2,
	title : 'Clock 2',
	img : Clock2
},{
	id : 3,
	title : 'Clock 3',
	img : Clock3
},{
	id : 4,
	title : 'Clock 4',
	img : Clock4
},{
	id : 5,
	title : 'Clock 5',
	img : Clock5
},{
	id : 6,
	title : 'Clock 6',
	img : Clock6
},{
	id : 7,
	title : 'Clock 7',
	img : Clock7
},]

export const defaultClockValue = () => {
	return {
		type : null,
		hour : 0,
		minute : 0,
		second : 0,
		is_hour_hidden : false,
		is_minute_hidden : false,
		is_second_hidden : false,
		format : null,
		analog : {
			template : null,
			styles : {
				width : 150,
				height : 150,
				font_color : '#000'
			}
		},  
		digital : {
			styles : {
				width : 250,
				height : 100,
				font_color : '#000'
			}
		}
	}
}



